import React from "react";
import Rooms from "./Rooms";

const Home = () => {
  return (
    <div className=" mx-auto min-h-screen overflow-x-hidden">
      <Rooms />
      {/* <UploadForm />
      <Gallery /> */}
      {/* <Footer /> */}
    </div>
  );
};

export default Home;
